import { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import css from './index.module.scss';

function EFSwiper(
    {
        spaceBetween,
        title,
        children,
        className = '',
    }: {
        spaceBetween: number;
        title?: string | JSX.Element;
        children: JSX.Element[] | JSX.Element;
        className?: string;
    },
    ref: any,
) {
    const swiperRef = useRef<HTMLDivElement | null>(null);
    const moveRef = useRef<HTMLDivElement | null>(null);
    const [offsetX, setOffsetX] = useState<number>(0);

    const handleClick = (direction?: string) => {
        if (direction === 'left') {
            const translateX = moveRef.current.offsetWidth - spaceBetween - swiperRef.current.offsetWidth;
            setOffsetX(-translateX);
        } else {
            setOffsetX(0);
        }
    };

    useImperativeHandle(ref, () => ({
        toLeft: () => handleClick('left'),
        toRight: () => handleClick('right'),
    }));

    return (
        <div className={`${css.ef_swiper} ef-swiper-ui ${className}`}>
            <div className="container ef-swiper-title">{title}</div>
            <div className="container ef-swiper-viewport" ref={swiperRef}>
                <div
                    className="move-viewport"
                    ref={moveRef}
                    style={{
                        transform: `translateX(${offsetX}px)`,
                    }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}

export default forwardRef(EFSwiper);
